require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-bs-ocaml-protoc.json") })
        }
      }, "path---package-bs-ocaml-protoc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-bs-ocaml-protoc!./.cache/json/package-bs-ocaml-protoc.json
// module id = 811
// module chunks = 231608221292675